import organizationApiFetch from "./organizationApiFetch";

const Calendar_SERVICE_URL = process.env.REACT_APP_CALENDAR_SERVICE_URL || "http://localhost:8087";

async function CalendarApiFetch(path, options = {}) {
    const {
        method = "GET",
        body = null,
        headers = {},
    } = options;
    
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    
    const requestHeaders = {
        "Content-Type": "application/json",
        ...headers,
    };

    const response = await organizationApiFetch(`${Calendar_SERVICE_URL}/calendar${normalizedPath}`, {
        method,
        headers: requestHeaders,
        body,
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch (error) {
        console.error("Error parsing JSON response:", error);
    }

    if (!response.ok) {
        const requestError = new Error(
            payload.error || payload.message || "An error occurred while fetching data."
        );
        requestError.status = response.status;
        requestError.details = payload.details;
        throw requestError;
    }

    return payload;
}       


export async function getAvailability(userID, month, duration, startDate = null) {
    const payload = {
        user_id: String(userID ?? ""),
        month: month ?? "",
        duration: Number(duration ?? 0),
        ...(startDate ? { start_date: startDate } : {}),
    };

    if (!payload.user_id || !payload.month || payload.duration <= 0) {
        throw new Error("Availability request is missing required fields.");
    }

    return CalendarApiFetch("/availability/index", {
        method: "POST",
        body: payload,
    });
}   


export async function getStaff() {
    return CalendarApiFetch("/availability/staff", {
        method: "GET",
    });
}